import React from 'react';
import { Typography } from '@material-ui/core';
import { TEXT, SPACE } from '../theme';

const SectionLabel = ({ children, action }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, margin: `${SPACE.lg}px 0 ${SPACE.sm}px` }}>
    <Typography variant="subtitle2" style={{ fontWeight: 700, color: TEXT.primary, whiteSpace: 'nowrap' }}>
      {children}
    </Typography>
    <div style={{ flex: 1, height: 1, backgroundColor: '#eef0f4' }} />
    {action}
  </div>
);

export default SectionLabel;
